import { createApp } from 'vue';
import App from './App.vue';
import ElementPlus from 'element-plus';
import router from './router';
import store from './store';
// import '@/libs/k2/bpmsformsdk.css'
import 'element-plus/theme-chalk/index.css';
import '@/styles/index.scss'; // global css
import '@/styles/components.scss';
import '@/styles/scrollbar.scss';
import 'normalize.css/normalize.css'; // a modern alternative to CSS resets
import './permission'; // permission control
import * as IconsVue from '@element-plus/icons-vue';
import i18n from '@/lang';
import customComponents from '@/components';
// import IbmpFlowcomponent from '@/libs/k2/bpmsformsdk.umd'
import request from '@/utils/request';
// import { refreshAccessToken } from '@/api/SSO/sso'
import initDirectives from './directive/permission';
let app = null;
export async function mount() {
  console.log('system mount');
  render();
}
export async function bootstrap() {
  console.log(' system bootstrap');
}
export async function unmount() {
  console.log('group-int-platform 被卸载了');
  app?.unmount();
  app = null;
}
// 独立运行时
if (!window.__POWERED_BY_QIANKUN__) {
  render();
} else {
  // eslint-disable-next-line no-undef
  // __webpack_public_path__ = 'http://localhost:9527/';
  __webpack_public_path__ = process.env.VUE_APP_API_PATH + '/';
}
async function render() {
  //   await checkSso()
  app = createApp(App);
  // UI框架
  app.use(ElementPlus);
  // 全局声明 icons-vue 图标组件
  for (let key of Object.keys(IconsVue)) {
    app.component(key, IconsVue[key]);
  }
  // 自定义指令
  initDirectives(app, store);
  // Vuex 统一状态管理
  app.use(store);
  // 多语言
  app.use(i18n);
  // k2 流程组件
  //   app.use(IbmpFlowcomponent)
  // 全局声明自定义通用组件
  for (let key of Object.keys(customComponents)) {
    app.component(key, customComponents[key]);
  }
  // 判断是否是web端
  function isWeb() {
    let platform = navigator.platform;
    let win = platform.match('Win'),
      mac = platform.match('Mac'),
      x11 = platform.match('Linux');
    let winWidth = window.screen.width;
    app.config.globalProperties.$pc = !!(win || mac || x11) && winWidth >= 450;
  }
  isWeb();
  const info = {
    username: '1'
  };
  // await store.dispatch('user/getInfo')
  if (sessionStorage.getItem('fromBipSso') === '1') {
    // 从bip统一认证登录页面跳转过来
    store.commit('sso/SETSSOENTRANCE', true);
    // // 埋点初始化
    // wkApiInit({
    //   bip: info.username
    // })
    // // 埋点上报用户画像
    // wkApiUser()
    sessionStorage.removeItem('fromBipSso');
  }
  // 获取权限
  //   let permissions = null
  //   if(info.username === 'sapyangjun' || info.username === 'hongweiteng'){
  //     await store.dispatch('menu/getPers')
  //   }
  // 路由集合，所有路由均在此处整合
  //   const menus = await store.dispatch('menu/getMenus')
  //   addRoutes(menus, permissions)
  // Router 路由导航
  app.use(router);
  // 全局声明 全局函数
  app.config.globalProperties.$request = request;
  app.mount('#integrationiplatform');
  // 获取合同分类数据
  // store.dispatch('main/getConClassifications')
  // 获取合同DomainList
  // store.dispatch('main/getDomainList')
  // setInterval(() => {
  //   refreshAccessToken(info.username+localStorage.getItem('clientCode'))
  // }, 500000) //1.5小时
}